import * as dataLayer from './AnalyticsDataLayer'
import { state$ as userAccountState$ } from '@core/State/UserAccount/userAccountDriver'
import { trackAccountNumber } from './Analytics'
import { fullClientVersion } from '@core/Utils/clientVersion'

export const trackTrendingBetSelected = (data: object): void =>
  trackEvent(dataLayer.keys.trendingBetSelected, { data })
export const trackTrendingBetSortingChanged = (data: object): void =>
  trackEvent(dataLayer.keys.trendingBetSortingChanged, { data })

export const trackRebet = (data: object): void => trackEvent(dataLayer.keys.rebet, { data })

export const trackActivityStatementsSelected = (accountNumber: number) => {
  trackEvent(dataLayer.keys.activityStatementsSelected, { accountNumber })
}

export const trackAccountActivityTab = (data: object): void =>
  trackEvent(dataLayer.keys.accountActivityTabChange, { data })

interface BonusBetTrackingMetadata {
  accountNumber: string | number | null
  accountBalance: number | null
  bonusBetBalance: number | null
  bonusCashBalance: number | null
  [key: string]: unknown
}

export const trackBonusBetEvent = (eventName: EventKey, metadata: BonusBetTrackingMetadata) => {
  trackEvent(eventName, metadata)
}

export const trackRacePromotionLoaded = () => trackEvent(dataLayer.keys.racePromotionLoaded, {})
export const trackRacePromotionOpened = () => trackEvent(dataLayer.keys.racePromotionOpened, {})
export const trackRacePromotionClosed = () => trackEvent(dataLayer.keys.racePromotionClosed, {})
export const trackRacePromotionTermsAndConditionsClicked = () =>
  trackEvent(dataLayer.keys.racePromotionTermsAndConditionsClicked, {})

export const trackRacePreviewLoaded = () => trackEvent(dataLayer.keys.racePreviewLoaded, {})
export const trackRacePreviewOpened = () => trackEvent(dataLayer.keys.racePreviewOpened, {})
export const trackRacePreviewClosed = () => trackEvent(dataLayer.keys.racePreviewClosed, {})

export const trackLoginSuccess = (
  accountNumber: string,
  keepLoggedIn: boolean,
  rememberAccount: boolean,
  isBioAuthUsed: boolean
) => {
  trackEvent(dataLayer.keys.loginSuccess, {
    accountNumber,
    keepLoggedIn,
    rememberAccount,
    isBioAuthUsed,
  })
}
export const trackLoginFailed = (accountIdentifier: string) => {
  trackEvent(dataLayer.keys.loginFailed, { accountIdentifier })
}
export const trackLogout = () => {
  trackEvent(dataLayer.keys.logout, { accountNumber: dataLayer.data.user.accountNumber })
  trackAccountNumber()
}
export const trackLoginForgotPassword = (accountIdentifier: string) =>
  trackEvent(dataLayer.keys.loginForgotPassword, { accountIdentifier })

export const trackLoginForgotAccountNumber = () => trackKey(dataLayer.keys.loginForgotAccountNumber)
export const trackLoginForgotAccountNumberSent = (deliveryMethod: string) =>
  trackEvent(dataLayer.keys.loginForgotAccountNumberSent, { deliveryMethod })
export const trackLoginResetPasswordSuccess = (accountNumber: string, deliveryMethod: string) =>
  trackEvent(dataLayer.keys.loginResetPasswordSucces, { accountNumber, deliveryMethod })

interface BiometricsToggleMetadata {
  isEnabled: boolean
  [key: string]: unknown
}
export const trackBiometricsToggle = (eventName: EventKey, metadata: BiometricsToggleMetadata) => {
  trackEvent(eventName, metadata)
}

// ==============
// Core Functions
// ==============

export type EventKey = (typeof dataLayer.keys)[keyof typeof dataLayer.keys]

export const trackKey = (key: EventKey): void => {
  userAccountState$?.take(1).subscribe(state => {
    const accountNumber = state?.accountNumber
    window.dataLayer?.push({ event: key, accountNumber, appVersion: fullClientVersion })
  })
}

export const trackEvent = (event: EventKey, data: Record<string | number, unknown>): void => {
  userAccountState$?.take(1).subscribe(state => {
    const accountNumber = state?.accountNumber
    window.dataLayer?.push({
      event,
      ...data,
      accountNumber: data?.accountNumber ?? accountNumber,
      appVersion: fullClientVersion,
    })
  })
}
